import { getPageTitleFromUrl } from '../util/getPageTitleFromUrl';
export default function loadNavigation(context, payload) {
    context.dispatch('UPDATE_PAGE_METADATA', {
        pageTitle: getPageTitleFromUrl(payload.url),
    });
}
